import TransferListTable from './transferListTable.container';

export default TransferListTable